import { useMutation } from '@tanstack/react-query';
import { useAtom } from 'jotai';

import { post } from 'api/utils';
import ENDPOINTS from 'api/utils/endpoints';
import { useSelectedDealerId } from '@lotlinx-aws/dealer-selector';
import { userAtom } from 'store';
import { assertIsDefined } from 'util/assert';

interface submitReportDownloadProps {
  token?: string;
  dealerId?: number;
  type: 'coreai' | 'vms' | 'vmp' | 'sentinel' | 'qbr';
}

/**
 * useReportDownload
 * @param prop
 */

async function submitReportDownload({ token, dealerId, type }: submitReportDownloadProps) {
  assertIsDefined(token);
  assertIsDefined(dealerId);

  return post(`${ENDPOINTS.reportsDownload}/${dealerId}`, {
    headers: { token },
    body: { type: type },
  });
}
export default function useReportDownload() {
  const [user] = useAtom(userAtom);
  const [dealerId] = useSelectedDealerId();
  return useMutation({
    mutationFn: ({ type }: submitReportDownloadProps) =>
      submitReportDownload({ token: user?.token, dealerId, type }),
  });
}
